import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { ContactApi } from "../../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../../services/Api/api";
import ContactPreview from "../../components/ContactPreview/ContactPreview";

interface MatchParams {
	contactId: string;
}

const OrganizationContactPreviewPage = () => {
	const [contact, setContact] = useState<ContactApi | undefined>(undefined);
	const [customFields, setCustomFields] = useState<CustomFieldTemplateApi[] | undefined>(undefined);
	const { contactId } = useParams<MatchParams>();
	const { addFlash } = useFlash();
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		onFetchContact();
		onFetchResources();
	}, []);

	const onFetchContact = async () => {
		try {
			const params = { include: "custom_fields" };
			const res = await api.organization().getContact(Number(contactId), params);
			setContact(res);
			handleChangeTabTitle(
				`${res.name ?? res.tax_id_no ?? res.contact_details?.email ?? res.contact_details?.phone_number} | ${t(
					"modules.contact.header.title"
				)}`
			);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const onFetchResources = async () => {
		try {
			const params = {
				resource_name: "CONTACT",
				custom_field_resource_type: "CONTACT",
				custom_field_permission_scope: "READ",
			};
			const res = await api.organization().getResourceTypes(params);
			setCustomFields(res.custom_fields);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!contact || !customFields) return <LoadingContainer />;

	return <ContactPreview contact={contact} customFields={customFields} />;
};

export default OrganizationContactPreviewPage;
